const data = [
  {
    id: 1,
    link: "http://droply.onrender.com",
    projectName: "Droply",
    description_a: ``,
    projectInfo: "An app that makes delivery experience seamless.",
    description_b: `React ● SASS ● Git ● Github ● React-Router ● Figma ● Responsive Design ●  `,
  },
  {
    id: 2,
    link: "http://stateofstates.onrender.com",
    projectName: "State of the States",
    description_a: `An App managed by the admin where posts and post types can be used to create data and populate the UI just by the click of a form. Another application to showcase my design skill and prowess. `,
    projectInfo:
      "An app to assess and rank the fiscal sustainability of Nigerian states annually, with a focus on their recovery from fiscal shocks caused by the 2020 Covid-19 pandemic and strategies for continued growth and resilience. ~ currently working on this",
    description_b: `React ● SASS ● Git ● Github ● React-Router ● Figma ● Responsive Design ●  `,
  },
  {
    id: 3,
    link: "https://deployn.onrender.com",
    projectName: "Deployn",
    description_a: `You would be able to sign in, subscribe to a suitable pricing and receive optimum service from Deployn service provider.`,
    projectInfo:
      "Deployn helps founders, project managers, and developers to build faster, access dev tools, and manage their tech infastructure via one simple integration.",
    description_b: `React ● SASS ● Git ● Github ● React-Router ● Figma ● Responsive Design`,
    repo: "https://github.com/barnascript/deploys",
  },
  {
    id: 4,
    link: "https://solveig.onrender.com",
    projectName: "SolveIg Design Studio",
    projectInfo: "A website where designs are showcased to clients",
    description_a: `I took a stab at SolveIg to flex my Frontend design Skills by taking on a Figma Design by Pawel Gola`,
    description_b: `React ● SASS ● Git ● Github ● React-Router ● Figma  ● Responsive Design`,
    repo: "https://github.com/barnascript/solveig",
  },
  {
    id: 5,
    link: "http://imperium-bg7p.onrender.com",
    projectName: "Imperium",
    projectInfo:
      "An App takes care of all your power and energy concerns by empowering your homes, stores and businesses with clean energy solutions",
    description_a: `Imperium is a concept project inspired by a design from @cavalon to flex my Frontend design Skills`,
    description_b: `React ● SASS ● Git ● Github ● React-Router ● Figma  ● Responsive Design ● SMTP Server ● Node ● Express`,
  },
  {
    //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
    id: 6,
    link: "https://url-xxqg.onrender.com",
    projectName: "Url Shortener",
    projectInfo: "Create short links. Share them anywhere.",
    description_a: `I took a stab at cloning Rebrandly.com, a popular Url Shortener and here is the outcome`,
    description_b: `React ● SASS ● Git ● Github ● React-Router ● Figma  ● Responsive Design ● SMTP Server ● Node ● Express ● MongoDB`,
    repo: "https://github.com/barnascript/url_shortener",
  },
  {
    id: 7,
    link: "https://css-utility.onrender.com",
    projectName: "Css Utility App",
    projectInfo: `Introducing the CSS Utility Pro: Your Ultimate Styling Companion!`,
    description_a: `Css Utility App was an ispiration from getcsscan.com where developers can copy css styles for free`,
    description_b: `React ● SASS ● Git ● Github ● React-Router ● Figma ● Responsive Design`,
    repo: "https://github.com/barnascript/css_utility_app",
  },
  //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
  {
    id: 8,
    link: "https://character-counter.onrender.com",
    projectName: "Character Calculator",
    projectInfo: `Word Counter and Character Calculator`,
    description_a: `Here is another concept but productive project where words and characters can be counted to save time and whose inspiration came from charactercalculator.com.,
    `,
    repo: "https://github.com/barnabasory/character-counter",
    description_b: `React ● SASS ● Git ● Github ● React-Router ● Figma ● Responsive Design ● React-Icons`,
  },
  {
    id: 9,
    link: "http://udus-m3bd.onrender.com",
    projectName: "University of Sokoto Website",
    projectInfo: `University of Sokoto Official Website: A Figma Design by @Cavalon`,
    description_a: `Welcome to the vibrant and dynamic online portal of the University of Sokoto, expertly designed by the creative minds at @Cavalon.`,
    description_b: `React ● CSS ● React-Router ● Figma ● Responsive Design ● React-Icons`,
  },
];

export default data;
